import { z } from "zod";
import { createInvoiceTemplateRequestSchema } from "../createInvoiceTemplate/createInvoiceTemplate.schema";

// Reuse the create schema but make all fields optional for PATCH
export const updateInvoiceTemplateRequestSchema =
  createInvoiceTemplateRequestSchema.partial().extend({
    id: z.string().min(1, "Template ID is required"),
  });

export type TUpdateInvoiceTemplateRequest = z.infer<
  typeof updateInvoiceTemplateRequestSchema
>;

export const updateInvoiceTemplateResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  companyID: z.string(),
  updatedAt: z.string().datetime(),
});

export type TUpdateInvoiceTemplateResponse = z.infer<
  typeof updateInvoiceTemplateResponseSchema
>;
